<template>
  <div>
    <div class="page-header">
      <el-page-header @back="goBack" :content="seriesName ? `${seriesName}的照片管理` : '照片管理'"></el-page-header>
    </div>

    <div class="search">
      <el-input placeholder="请输入标题查询" style="width: 200px" v-model="title"></el-input>
      <el-select v-model="seriesId" placeholder="请选择系列" style="width: 150px; margin-left: 10px" clearable 
                :disabled="!!$route.query.seriesId">
        <el-option
          v-for="item in seriesOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button type="info" plain style="margin-left: 10px" @click="load(1)">查询</el-button>
      <el-button type="warning" plain style="margin-left: 10px" @click="reset">重置</el-button>
    </div>

    <div class="operation">
      <el-button type="primary" plain @click="handleAdd">新增</el-button>
      <el-button type="success" plain @click="handleBatchUpload">批量上传</el-button>
      <el-button type="danger" plain @click="delBatch">批量删除</el-button>
    </div>

    <div class="table">
      <el-table :data="tableData" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="id" label="序号" width="80" align="center" sortable></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="seriesName" label="所属系列" width="120"></el-table-column>
        <el-table-column label="图片" width="180">
          <template v-slot="scope">
            <el-image style="width: 100px; height: 60px" :src="scope.row.imageUrl" fit="cover" 
                     :preview-src-list="[scope.row.imageUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center"></el-table-column>
        <el-table-column label="是否封面" width="100" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.isCover ? 'success' : 'info'">{{ scope.row.isCover ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template v-slot="scope">
            <el-button plain type="primary" @click="handleEdit(scope.row)" size="mini">编辑</el-button>
            <el-button plain type="danger" size="mini" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 单张照片上传表单 -->
    <el-dialog title="照片信息" :visible.sync="formVisible" width="40%" :close-on-click-modal="false" destroy-on-close>
      <el-form label-width="100px" style="padding-right: 50px" :model="form" :rules="rules" ref="formRef">
        <el-form-item prop="title" label="标题">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="seriesId" label="所属系列">
          <el-select v-model="form.seriesId" placeholder="请选择系列" style="width: 100%" 
                    :disabled="!!$route.query.seriesId">
            <el-option
              v-for="item in seriesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="imageUrl" label="图片">
          <el-upload
              class="avatar-uploader"
              :action="$baseUrl + '/files/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
            <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="description" label="描述">
          <el-input type="textarea" :rows="3" v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="isCover" label="是否封面">
          <el-switch v-model="form.isCover"></el-switch>
        </el-form-item>
        <el-form-item prop="sortOrder" label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" :max="1000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量上传表单 -->
    <el-dialog title="批量上传照片" :visible.sync="batchUploadVisible" width="50%" :close-on-click-modal="false" destroy-on-close>
      <el-form label-width="100px" style="padding-right: 50px" :model="batchForm" :rules="batchRules" ref="batchFormRef">
        <el-form-item prop="seriesId" label="所属系列">
          <el-select v-model="batchForm.seriesId" placeholder="请选择系列" style="width: 100%" 
                    :disabled="!!$route.query.seriesId">
            <el-option
              v-for="item in seriesOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="photos" label="上传图片">
          <el-upload
              class="upload-demo"
              :action="$baseUrl + '/files/upload'"
              :on-success="handleBatchSuccess"
              :on-remove="handleBatchRemove"
              multiple
              :limit="20"
              list-type="picture-card">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="titlePrefix" label="标题前缀">
          <el-input v-model="batchForm.titlePrefix" placeholder="可选，例如：'婚纱照-'，会自动加上序号" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchUploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBatch">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Photo",
  data() {
    return {
      tableData: [],  // 所有的数据
      pageNum: 1,   // 当前的页码
      pageSize: 10,  // 每页显示的个数
      total: 0,
      title: null,
      seriesId: this.$route.query.seriesId || null,
      seriesName: this.$route.query.seriesName || '',
      seriesOptions: [],
      formVisible: false,
      form: {
        sortOrder: 0,
        isCover: false,
        seriesId: this.$route.query.seriesId || null
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        seriesId: [
          {required: true, message: '请选择所属系列', trigger: 'change'},
        ],
        imageUrl: [
          {required: true, message: '请上传图片', trigger: 'blur'},
        ],
        sortOrder: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ]
      },
      batchUploadVisible: false,
      batchForm: {
        seriesId: this.$route.query.seriesId || null,
        titlePrefix: '',
        photos: []
      },
      batchRules: {
        seriesId: [
          {required: true, message: '请选择所属系列', trigger: 'change'},
        ],
        photos: [
          {required: true, type: 'array', min: 1, message: '请至少上传一张照片', trigger: 'change'},
        ]
      },
      ids: []
    }
  },
  created() {
    this.loadSeries()
    this.load(1)
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    loadSeries() {
      this.$request.get('/photo/series/list').then(res => {
        if (res.code === '200') {
          this.seriesOptions = res.data.list || res.data
        }
      })
    },
    handleAvatarSuccess(res) {
      if (res.code === '200') {
        this.form.imageUrl = res.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleBatchSuccess(res, file) {
      if (res.code === '200') {
        this.batchForm.photos.push({
          url: res.data,
          name: file.name,
          uid: file.uid
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    handleBatchRemove(file) {
      const index = this.batchForm.photos.findIndex(item => item.uid === file.uid)
      if (index !== -1) {
        this.batchForm.photos.splice(index, 1)
      }
    },
    handleAdd() {   // 新增数据
      this.form = {
        sortOrder: 0,
        isCover: false,
        seriesId: this.$route.query.seriesId || null
      }  // 新增数据的时候设置默认值
      this.formVisible = true   // 打开弹窗
    },
    handleEdit(row) {   // 编辑数据
      this.form = JSON.parse(JSON.stringify(row))  // 给form对象赋值  注意要深拷贝数据
      this.formVisible = true   // 打开弹窗
    },
    handleBatchUpload() {
      this.batchForm = {
        seriesId: this.$route.query.seriesId || null,
        titlePrefix: '',
        photos: []
      }
      this.batchUploadVisible = true
    },
    save() {   // 保存按钮触发的逻辑  它会触发新增或者更新
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$request({
            url: this.form.id ? '/photo/admin/' + this.form.id : '/photo/admin',
            method: this.form.id ? 'PUT' : 'POST',
            data: this.form
          }).then(res => {
            if (res.code === '200') {  // 表示成功保存
              this.$message.success('保存成功')
              this.load(1)
              this.formVisible = false
            } else {
              this.$message.error(res.msg)  // 弹出错误的信息
            }
          })
        }
      })
    },
    saveBatch() {
      this.$refs.batchFormRef.validate((valid) => {
        if (valid) {
          const photos = this.batchForm.photos.map((photo, index) => {
            return {
              seriesId: this.batchForm.seriesId,
              imageUrl: photo.url,
              title: this.batchForm.titlePrefix ? `${this.batchForm.titlePrefix}${index + 1}` : `照片${index + 1}`,
              isCover: index === 0 && this.batchForm.photos.length > 0,
              sortOrder: index
            }
          })
          
          this.$request({
            url: '/photo/batch',
            method: 'POST',
            data: photos
          }).then(res => {
            if (res.code === '200') {
              this.$message.success('批量上传成功')
              this.load(1)
              this.batchUploadVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    del(id) {   // 单个删除
      this.$confirm('您确定删除吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {  // 用户点击确定按钮
        this.$request.delete('/photo/admin/' + id).then(res => {
          if (res.code === '200') {
            this.$message.success('删除成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
    },
    delBatch() {   // 批量删除
      if (!this.ids.length) {
        this.$message.warning('请选择数据')
        return
      }
      this.$confirm('您确定批量删除这些数据吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {  // 用户点击确定按钮
        this.$request.delete('/photo/admin/batch', {
          data: this.ids
        }).then(res => {
          if (res.code === '200') {
            this.$message.success('批量删除成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    load(pageNum) {  // 分页查询
      this.loadSeries()
      this.pageNum = pageNum
      this.$request.get('/photo/admin/list', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          title: this.title,
          seriesId: this.seriesId
        }
      }).then(res => {
        if (res.code === '200') {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reset() {
      this.title = null
      this.seriesId = this.$route.query.seriesId || null
      this.load(1)
    },
    handleCurrentChange(pageNum) {
      this.load(pageNum)
    },
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
}

.avatar-uploader {
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style> 